/** @format */
import { useEffect } from 'react';
import checkIcon from '../../_config/images/check-magistal.png';
import { useHistory, useLocation } from 'react-router-dom';
import './style.scss';
import CustomButton from '../../v2-components/Antd/Button';

export default function CheckoutPreorder() {
	const history = useHistory();
	const location = useLocation();

	const trackingId = location.state?.trackingId;

	useEffect(() => {
		if (!trackingId) {
			history.replace('/');
			return;
		}

		localStorage.removeItem('paymentData');
		localStorage.removeItem('voucherCode');
	}, [trackingId, history]);

	useEffect(() => {
		window.history.pushState(null, '', window.location.href);

		const onPopState = () => {
			window.history.pushState(null, '', window.location.href);
		};

		window.addEventListener('popstate', onPopState);
		return () => window.removeEventListener('popstate', onPopState);
	}, []);

	const handleGoHome = () => {
		window.location.replace('/');
	};

	return (
		<div className="ph-preorder-success-page">
			<div className="ph-preorder-success-card">
				<img src={checkIcon} alt="Check" className="ph-preorder-success-icon-img" />

				<p className="ph-preorder-success-title">Pre-orden registrada con éxito</p>

				<p className="ph-preorder-success-subtitle">
					Pre-orden n° {trackingId}
					<br />
					Recibimos tu solicitud y la estaremos procesando a la brevedad.
				</p>

				<CustomButton className="ph-checkout-address-btn enabled-button ph-preorder-success-btn" onClick={handleGoHome}>
					<p className="ph-checkout-text-btn">Ir al inicio</p>
				</CustomButton>
			</div>
		</div>
	);
}
